var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"fixed-tabs":"","background-color":"white"}},[_c('v-tab',{attrs:{"to":{ name: 'requests' }}},[_vm._v("Mine")]),_c('v-tab',{attrs:{"to":{ name: 'JointOwnerships' }}},[_vm._v("Sameiets")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }